/// <amd-module name="DistributedTaskUI/SecurityComponent/PipelinePermissionsAuthorization/Components/PipelinesListComponent" />
import * as React from "react";
import * as Resources from "DistributedTaskUI/SecurityComponent/Resources";
import { BuildDefinitionReference } from "DistributedTaskUI/SecurityComponent/PipelinePermissionsAuthorization/Source/Build/Contracts/Build";
import { VssComponent, IVssComponentContext } from "VSS/Platform/Layout";
import { ExpandableButton } from "VSSUI/Button";
import { IExpandable } from "VSSUI/Expandable";
import { Callout } from "VSSUI/Callout";
import { IOffset, IOrigin, IPoint } from "VSSUI/Utilities/Position";
import { PickList, IPickListSelection } from "VSSUI/PickList";

export interface IAuthorizePipelinesDropDownComponentProps {
    items: BuildDefinitionReference[];
    canEditPipelinePermission?: boolean;
    onSelectionChanged: (selection: IPickListSelection<BuildDefinitionReference>) => void | boolean;
}

export class PipelinesListComponent extends VssComponent<IAuthorizePipelinesDropDownComponentProps, {}> {
    constructor(props: IAuthorizePipelinesDropDownComponentProps, context: IVssComponentContext) {
        super(props, context);
    }

    public render(): React.ReactNode {
        return (
            <ExpandableButton
                disabled={!this.props.items || this.props.items.length === 0 || this.props.canEditPipelinePermission === false}
                className="pipelines-permissions-card-header-add-button"
                id="add-pipeline-permission"
                renderCallout={this._renderPipelinesList}
                iconProps= {{
                    iconName: "Add"
                }}
                hideDropdownIcon={true}
                ariaLabel={Resources.AuthorizePipelinesTooltip}
            />
        );
    }

    private _renderPipelinesList = (
        dropdown: IExpandable,
        dropdownId: string,
        anchorElement?: HTMLElement,
        anchorOffset?: IOffset,
        anchorOrigin?: IOrigin,
        anchorPoint?: IPoint,
        dropdownOrigin?: IOrigin
    ): JSX.Element => {
        return (
            <Callout
                className="pipelines-permissions-add-dropdown-callout depth-8"
                anchorElement={anchorElement}
                anchorOffset={anchorOffset}
                anchorOrigin={anchorOrigin}
                anchorPoint={anchorPoint}
                calloutOrigin={dropdownOrigin}
                onDismiss={dropdown.collapse}
                escDismiss={true}
                blurDismiss={true}
                lightDismiss={true}
            > 
                <PickList
                    className="pipelines-permissions-add-dropdown-list"
                    width={256}
                    maxHeight={360}
                    getListItem={(item: BuildDefinitionReference) => {
                        return {
                            name: item.name,
                            key: item.id.toString(),
                            iconProps: {
                                iconName: "Rocket",
                                className: "pipeline-list-icon"
                            }
                        };
                    }}
                    ref={(ref) => { if (ref) {ref.focus(); } } }
                    items={this.props.items}
                    isSearchable={true}
                    onSelectionChanged={(selection) => {
                        this.props.onSelectionChanged(selection);
                        dropdown.collapse();
                    }}
                    onFocusLost={() => {
                        dropdown.collapse();
                    }}
                    minItemsForSearchBox={1}
                    searchBoxAriaLabel="Search pipelines"
                />
            </Callout>
        );
    }
}
